import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useScrollReveal } from '../hooks/useScrollReveal';

const AboutPage = () => {
  // Scroll reveal hooks
  const journeyReveal = useScrollReveal({ threshold: 0.15 });
  const founderReveal = useScrollReveal({ threshold: 0.15 });
  const philosophyReveal = useScrollReveal({ threshold: 0.2 });
  const missionReveal = useScrollReveal({ threshold: 0.15 });
  // const teamReveal = useScrollReveal({ threshold: 0.1 });

  // const team = [
  //   {
  //     name: "Sarah Mitchell",
  //     role: "Founder & Head Groomer",
  //     image:
  //       "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=300&h=300&fit=crop&auto=format",
  //     experience: "12+ years",
  //   },
  //   {
  //     name: "Dr. James Chen",
  //     role: "Veterinary Consultant",
  //     image:
  //       "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=300&fit=crop&auto=format",
  //     experience: "15+ years",
  //   },
  //   {
  //     name: "Emily Rodriguez",
  //     role: "Daycare Manager",
  //     image:
  //       "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=300&h=300&fit=crop&auto=format",
  //     experience: "8+ years",
  //   },
  //   {
  //     name: "Michael Thompson",
  //     role: "Senior Pet Care Specialist",
  //     image:
  //       "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300&h=300&fit=crop&auto=format",
  //     experience: "10+ years",
  //   },
  // ];



  return (
    <div className="min-h-screen visitor-page">
      <Navbar />
      {/* How It Started — Our Journey with scroll animation */}
      <section className="bg-gradient-to-br from-white via-domigo-pink/10 to-domigo-purple/5 py-6 lg:py-8">
        <div
          ref={journeyReveal.ref}
          className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 ${journeyReveal.isVisible
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 translate-y-12'
            }`}
        >
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h2 className="text-3xl font-bold bg-gradient-to-r from-gray-900 via-domigo-pink to-domigo-purple bg-clip-text text-transparent mb-4">
                How It Started — Our Journey
              </h2>
              <div className="space-y-3 text-lg text-gray-600 leading-relaxed">
                <p>
                  Domigo didn’t start with a business plan. It started with discomfort — the discomfort of seeing dogs waiting.
                </p>
                <p>
                  Waiting in kennels. Waiting for pickup. Waiting for time to pass.
                </p>
                <p className="font-semibold">Dogs deserve better than waiting rooms.</p>
                <p>
                  So Domigo was built as a living room, then a playground, then a social ecosystem.
                </p>
                <p>
                  Today, Domigo is redefining dog boarding in Indore with structured pack systems, emotional wellbeing, and premium hospitality.
                </p>
              </div>
            </div>
            <div className="relative">
              <div className="w-full h-96 lg:h-[400px] rounded-3xl overflow-hidden shadow-large">
                <img
                  src="https://images.unsplash.com/photo-1601758228041-f3b2795255f1?w=800&h=800&fit=crop&auto=format"
                  alt="Happy pets at Domigo"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute top-6 left-6 bg-gradient-pink text-white px-6 py-3 rounded-full font-bold text-lg shadow-pink">
                11+ Years
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About the Founder with scroll animation */}
      <section className="bg-gradient-to-b from-white to-gray-50 py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div
            ref={founderReveal.ref}
            className={`bg-white p-8 rounded-3xl depth-xl card-hover transition-all duration-1000 ${founderReveal.isVisible
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 translate-y-12'
              }`}
          >
            <h2 className="text-3xl font-bold bg-gradient-to-r from-domigo-purple to-domigo-purple bg-clip-text text-transparent mb-4 text-center">
              Meet the Founder
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
              {/* Left: founder image (responsive) - replace src with actual founder photo if available */}
              <div className="md:col-span-1">
                <div className="w-full h-64 md:h-96 rounded-3xl overflow-hidden bg-gray-50 flex items-center justify-center relative">
                  <img
                    src="/image1.JPG"
                    alt="Founder - Akshay Shelat"
                    style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
                  />
                  {/* Decorative curved bottom overlay */}
                  <svg className="absolute bottom-0 left-0 w-full h-16" viewBox="0 0 100 20" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                    <path d="M0 20 C20 0 80 0 100 20 L100 20 L0 20 Z" fill="#ffffff" />
                  </svg>
                </div>
              </div>

              {/* Right: founder text (kept exactly as provided) */}
              <div className="md:col-span-2 space-y-3 text-gray-600 leading-relaxed text-center md:text-left">

                <p className="text-xl font-semibold text-brand-primary mb-2">Akshay Shelat</p>

                <p>Welcome to Domigo — where care feels like home, and every stay becomes a story.</p>

                <p>Founded by Akshay Shelat, Domigo was built with a simple yet powerful vision — to create a second home where dogs feel safe, loved, and truly cared for.</p>

                <p>As a passionate dog lover and pet parent, Akshay Shelat understood the emotional connection families share with their dogs. He recognized that pet boarding should never feel stressful or impersonal. It should feel warm, joyful, and reassuring — for both dogs and their humans.</p>

                <p>With that belief, Domigo was created to offer structured play, supervised care, and a welcoming environment that prioritizes comfort, safety, and happiness.</p>

                <p>Today, Domigo stands as more than just a daycare or boarding space — it is a community built on trust, transparency, and countless happy tail wags.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Domigo Philosophy with scroll animation */}
      <section className="bg-white py-12 lg:py-16">
        <div
          ref={philosophyReveal.ref}
          className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 ${philosophyReveal.isVisible
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 translate-y-12'
            }`}
        >
          <h2 className="text-3xl font-bold text-center bg-gradient-to-r from-gray-900 via-domigo-pink to-domigo-purple bg-clip-text text-transparent mb-4">
            Domigo Philosophy
          </h2>
          <div className="max-w-3xl mx-auto text-gray-600 text-lg space-y-4">
            <p className="text-lg text-center mb-0">Dogs are social creatures — not storage items.</p>
            <div>
              <p className="mb-2">They need:</p>
              <ul className="list-disc list-inside space-y-2 mb-0">
                <li>Movement</li>
                <li>Belonging</li>
                <li>Companionship</li>
              </ul>
            </div>
            <p className="font-semibold mb-0">Domigo exists to provide exactly that.</p>
          </div>
        </div>
      </section>

      {/* Mission & Vision with scroll animation */}
      <section className="bg-gradient-to-b from-white to-gray-50 py-12 lg:py-16">
        <div
          ref={missionReveal.ref}
          className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 ${missionReveal.isVisible
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 translate-y-12'
            }`}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-3xl depth-xl card-hover group">
              <h2 className="text-3xl font-bold bg-gradient-to-r from-domigo-purple to-domigo-purple bg-clip-text text-transparent mb-4">
                Mission Statement
              </h2>
              <p className="text-gray-600 leading-relaxed">
                To create the happiest, safest, and most socially fulfilling dog boarding experience in Indore.
              </p>
            </div>
            <div className="bg-white p-8 rounded-3xl depth-xl card-hover group">
              <h2 className="text-3xl font-bold bg-gradient-to-r from-domigo-purple to-domigo-blue bg-clip-text text-transparent mb-4">
                Vision Statement
              </h2>
              <p className="text-gray-600 leading-relaxed">
                To transform pet hospitality from basic care into meaningful life experiences.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Team */}
      <section className="bg-white py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-center bg-gradient-to-r from-gray-900 via-domigo-pink to-domigo-purple bg-clip-text text-transparent mb-4">
            🐾 Our Team
          </h2>
          <p className="text-lg text-center text-gray-600 mb-4 max-w-3xl mx-auto">
            Behind every great dog experience is a deeply committed human.
          </p>

          <div className="max-w-5xl mx-auto text-gray-600 text-lg mb-6">
            <p>At Domigo, our strength lies in the passionate professionals who dedicate their time, energy, and heart to every dog in our care. Each team member is carefully selected, trained, and aligned with our philosophy of safety, structure, and warmth.</p>

            <p className="font-semibold mt-4 mb-2">Domigo Team Includes:</p>
            <ul className="list-disc list-inside space-y-2 mb-4">
              <li><strong>Pack Behaviour Specialists</strong> – Experts in understanding social dynamics and ensuring safe, structured group interactions.</li>
              <li><strong>Experienced Dog Handlers</strong> – Trained professionals who supervise play, monitor behavior, and provide attentive care throughout the day.</li>
              <li><strong>Grooming Experts</strong> – Skilled specialists focused on hygiene, comfort, and maintaining each dog’s well-being.</li>
              <li><strong>Training Professionals</strong> – Dedicated to reinforcing positive behavior, social skills, and confidence-building.</li>
              <li><strong>Overnight Care Staff</strong> – Ensuring comfort, supervision, and peace of mind during extended stays.</li>
            </ul>

            <p className="font-semibold">Available 24×7 — because dogs don’t operate on office hours, and neither does our commitment to their care.</p>

            <p className="mt-4">At Domigo, every wag is watched, every need is noticed, and every dog is treated like family.</p>
          </div>

          {/* <div
            ref={teamReveal.ref}
            className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 transition-all duration-1000 ${teamReveal.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
          >
            {team.map((member, index) => (
              <div
                key={index}
                className="bg-white rounded-3xl shadow-soft overflow-hidden hover:shadow-large hover-lift transition-all duration-300"
              >
                <div className="h-64">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    {member.name}
                  </h3>
                  <p className="text-domigo-pink font-semibold mb-2">
                    {member.role}
                  </p>
                  <p className="text-gray-600 text-sm">
                    {member.experience} experience
                  </p>
                </div>
              </div>
            ))}
          </div> */}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
